import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {ServiceType} from "../../../model/service-type";
import {
  RefServiceCondition,
  RefServiceMode,
  RefServiceStatus,
  RefServiceStatusFacet
} from "../../../model/service/service-ref";

export interface RefSelectorProps {
  showDoNotUse?: boolean;
}

const getShowDoNotUseParam = createParamSelector<RefSelectorProps | undefined, boolean | undefined>(params => params?.showDoNotUse)

export const refServiceConditionsSelector = () => createSelector(
  [getUseQueryResultData<RefServiceCondition[]>, getShowDoNotUseParam],
  (data, showDoNotUse) => {
    return selectRefServiceConditions(data, {showDoNotUse: showDoNotUse});
  }
);

export const refServiceConditionSelector = () => createSelector(
  [getUseQueryResultData<ServiceType>],
  (data) => {
    return data
  }
);

export const selectRefServiceConditions = (values?: RefServiceCondition[], selector?: RefSelectorProps): RefServiceCondition[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    const showDoNotUse = selector?.showDoNotUse ?? false;
    if (filterIn && !showDoNotUse && v.doNotUse) {
      filterIn = false;
    }

    return filterIn;
  });
};

export const refServiceModesSelector = () => createSelector(
  [getUseQueryResultData<RefServiceMode[]>, getShowDoNotUseParam],
  (data, showDoNotUse) => {
    return selectRefServiceModes(data, {showDoNotUse: showDoNotUse});
  }
);

export const refServiceModeSelector = () => createSelector(
  [getUseQueryResultData<ServiceType>],
  (data) => {
    return data
  }
);

export const selectRefServiceModes = (values?: RefServiceMode[], selector?: RefSelectorProps): RefServiceMode[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    const showDoNotUse = selector?.showDoNotUse ?? false;
    if (filterIn && !showDoNotUse && v.doNotUse) {
      filterIn = false;
    }

    return filterIn;
  });
};

export const refServiceStatusesSelector = () => createSelector(
  [getUseQueryResultData<RefServiceStatus[]>, getShowDoNotUseParam],
  (data, showDoNotUse) => {
    return selectRefServiceStatuses(data, {showDoNotUse: showDoNotUse});
  }
);

export const refServiceStatusSelector = () => createSelector(
  [getUseQueryResultData<ServiceType>],
  (data) => {
    return data
  }
);

export const selectRefServiceStatuses = (values?: RefServiceStatus[], selector?: RefSelectorProps): RefServiceStatus[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    const showDoNotUse = selector?.showDoNotUse ?? false;
    if (filterIn && !showDoNotUse && v.doNotUse) {
      filterIn = false;
    }

    return filterIn;
  });
};

export const refServiceStatusFacetsSelector = () => createSelector(
  [getUseQueryResultData<RefServiceStatusFacet[]>, getShowDoNotUseParam],
  (data, showDoNotUse) => {
    return selectRefServiceStatusFacets(data, {showDoNotUse: showDoNotUse});
  }
);

export const refServiceStatusFacetSelector = () => createSelector(
  [getUseQueryResultData<ServiceType>],
  (data) => {
    return data
  }
);

export const selectRefServiceStatusFacets = (values?: RefServiceStatusFacet[], selector?: RefSelectorProps): RefServiceStatusFacet[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    const showDoNotUse = selector?.showDoNotUse ?? false;
    if (filterIn && !showDoNotUse && v.doNotUse) {
      filterIn = false;
    }

    return filterIn;
  });
};
